/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiApprenticeship } from '../models/jofi-apprenticeship';
import { JofiCreateApprenticeshipDto } from '../models/jofi-create-apprenticeship-dto';
import { JofiUpdateApprenticeshipDto } from '../models/jofi-update-apprenticeship-dto';

@Injectable({
  providedIn: 'root',
})
export class JofiContentManagementApprenticeshipsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apprenticeshipsControllerFindAllByCompanyId
   */
  static readonly ApprenticeshipsControllerFindAllByCompanyIdPath = '/v1/content-management/apprenticeships/byCompanyId/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipsControllerFindAllByCompanyId()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipsControllerFindAllByCompanyId$Response(params: {
    companyId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiApprenticeship>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipsService.ApprenticeshipsControllerFindAllByCompanyIdPath, 'get');
    if (params) {
      rb.path('companyId', params.companyId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiApprenticeship>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipsControllerFindAllByCompanyId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipsControllerFindAllByCompanyId(params: {
    companyId: string;
    context?: HttpContext
  }
): Observable<Array<JofiApprenticeship>> {

    return this.apprenticeshipsControllerFindAllByCompanyId$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiApprenticeship>>) => r.body as Array<JofiApprenticeship>)
    );
  }

  /**
   * Path part for operation apprenticeshipsControllerFindById
   */
  static readonly ApprenticeshipsControllerFindByIdPath = '/v1/content-management/apprenticeships/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipsControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipsControllerFindById$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiApprenticeship>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipsService.ApprenticeshipsControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeship>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipsControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipsControllerFindById(params: {
    id: string;
    context?: HttpContext
  }
): Observable<JofiApprenticeship> {

    return this.apprenticeshipsControllerFindById$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeship>) => r.body as JofiApprenticeship)
    );
  }

  /**
   * Path part for operation apprenticeshipsControllerRemove
   */
  static readonly ApprenticeshipsControllerRemovePath = '/v1/content-management/apprenticeships/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipsControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipsControllerRemove$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipsService.ApprenticeshipsControllerRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipsControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apprenticeshipsControllerRemove(params: {
    id: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.apprenticeshipsControllerRemove$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apprenticeshipsControllerUpdate
   */
  static readonly ApprenticeshipsControllerUpdatePath = '/v1/content-management/apprenticeships/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apprenticeshipsControllerUpdate$Response(params: {
    id: string;
    context?: HttpContext
    body: JofiUpdateApprenticeshipDto
  }
): Observable<StrictHttpResponse<JofiApprenticeship>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipsService.ApprenticeshipsControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeship>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apprenticeshipsControllerUpdate(params: {
    id: string;
    context?: HttpContext
    body: JofiUpdateApprenticeshipDto
  }
): Observable<JofiApprenticeship> {

    return this.apprenticeshipsControllerUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeship>) => r.body as JofiApprenticeship)
    );
  }

  /**
   * Path part for operation apprenticeshipsControllerCreate
   */
  static readonly ApprenticeshipsControllerCreatePath = '/v1/content-management/apprenticeships';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apprenticeshipsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apprenticeshipsControllerCreate$Response(params: {
    context?: HttpContext
    body: JofiCreateApprenticeshipDto
  }
): Observable<StrictHttpResponse<JofiApprenticeship>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementApprenticeshipsService.ApprenticeshipsControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiApprenticeship>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apprenticeshipsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apprenticeshipsControllerCreate(params: {
    context?: HttpContext
    body: JofiCreateApprenticeshipDto
  }
): Observable<JofiApprenticeship> {

    return this.apprenticeshipsControllerCreate$Response(params).pipe(
      map((r: StrictHttpResponse<JofiApprenticeship>) => r.body as JofiApprenticeship)
    );
  }

}
